const INFO = {
	main: {
		title: "Doni-folio: byme",
		name: "Donizetti deSouza",
		email: "dictum.dingo-0t@icloud.com", //colocar
		logo: "../logo.png", //colocar
	},

	stacks: {
		all: [
			"../logosStacks/swift.png",
			"../logosStacks/swiftui.png",
			"../logosStacks/cocoapods.png",
			"../logosStacks/xcode.png",
			"../logosStacks/api.png",
			"../logosStacks/firebase.png",
			"../logosStacks/sql.jpg",
			"../logosStacks/node.svg",
			"../logosStacks/git.png",
			"../logosStacks/google-cloud.png",
			"../logosStacks/aws.jpg",
			"../logosStacks/azure.png",
			"../logosStacks/ios.png",	
		]
	},

	// stacks: {
	// 	all: [
	// 		"../logosStacks/python.png",
	// 		"../logosStacks/java.png",
	// 		"../logosStacks/brain.jpg",
	// 		"../logosStacks/r.png",
	// 		"../logosStacks/matlab.png",
	// 		"../logosStacks/javascript.png",
	// 		"../logosStacks/html.png",
	// 		"../logosStacks/css.jpg",
	// 		"../logosStacks/react.svg",
	// 		"../logosStacks/node.svg",
	// 		"../logosStacks/swift.png",
	// 		"../logosStacks/matplotlib.png",
	// 		"../logosStacks/pandas.png",
	// 		"../logosStacks/seaborn.png",
	// 		"../logosStacks/numpy.png",
	// 		"../logosStacks/sql.jpg",
	// 		"../logosStacks/mongoDB.png",
	// 		"../logosStacks/google-cloud.png",
	// 		"../logosStacks/aws.jpg",
	// 		"../logosStacks/azure.png",
	// 	]
	// },

	socials: {
		twitter: "https://twitter.com/junior_10v",
		github: "https://github.com/souza10v",
		linkedin: "https://www.linkedin.com/in/doni-souza-298a3a280/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/users/13582831/imperador-catalano",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Desenvolvedor iOS ",
		description:
			"Sou um desenvolvedor iOS apaixonado pela criação de experiências digitais excepcionais. Com experiência sólida em Swift, SwiftUI e arquiteturas iOS, estou pronto para contribuir com projetos inovadores que desafiem os limites da tecnologia móvel. Busco aplicar minha expertise em desenvolvimento de aplicativos móveis e otimização de desempenho para oferecer soluções eficientes e impactantes."
	},

	about: {
		title: "Me chamo Doni-zetti, mineiro e desenvolvedor iOS, dedicado a criar soluções móveis que encantam e surpreendem.",
		description: "Tenho experiência em desenvolvimento iOS, mestrado na área computacional e bacharelado em ciências da computação.  Durante minha carreira estive ativamente envolvido em diversos projetos envolvendo diferentes tecnologias, com destaque para o desenvolvimento de aplicações iOS e outras áreas do ecossistema tecnológico como front-end, backiend e conhecimentos avançados de bancos de dados." +
			"\n\n" +
			"Muitos dos aplicativos e soluções em que trabalho estão abertos para que outros possam explorar e contribuir. Se você estiver interessado em algum dos projetos em que trabalho, sinta-se à vontade para revisar o código e sugerir melhorias ou aprimoramentos. Trabalhar com outras pessoas é uma ótima maneira de aprender e crescer, e estou sempre aberto a novas ideias e feedback." +
			"\n\n" +
			"Essa experiência me proporcionou uma compreensão profunda do desenvolvimento de aplicativos móveis, desde o conceito até a entrega final, incluindo a colaboração no desenvolvimento para iOS com SwiftUI como foco principal e a integração de serviços de API para buscar e exibir dados relevantes no aplicativo." +
			"\n\n" +
			"Além disso, ganhei experiência internacional, morando nos Estados Unidos e na Nova Zelândia por dois anos, o que ampliou minha perspectiva multicultural e capacidade de trabalhar de forma eficaz em diferentes ambientes. Sou enérgico e desafiado, buscando constantemente aprender e crescer profissionalmente. Possuo sólidas habilidades de trabalho em equipe e foco na eficiência e colaboração para atingir objetivos. Atualizo e me adapto constantemente às novas tecnologias e métodos de trabalho, garantindo entrega de alta qualidade e contribuindo para o sucesso dos projetos."
	},


	articles: {
		title: "Tenho paixão por explorar e compartilhar conhecimento: \"Knowledge is power and sharing knowledge is empowering\".",
		description:
			"Algumas das minhas ideias e opiniões ao longo do tempo sobre programação, viajens, design e muito mais.",
	},

	projects: [
		{
			title: "Ski Resort Mountain App",
			description:
				"O aplicativo oferece informações essenciais para esquiadores e snowboarders, incluindo condições climáticas atualizadas, mapas de pistas e serviços de aluguel de equipamentos, proporcionando uma experiência completa nas montanhas.",
			logos: [
				"../logosStacks/swift.png",
				"../logosStacks/swiftui.png",
				"../logosStacks/node.svg",
				"../logosStacks/api.png",
				"../logosStacks/sql.jpg",
				"../logosStacks/ios.png",
			],
			linkText: "Ver Projeto",
			link: "https://github.com/souza10v/Mountain-Resort",
		},

		{
			title: "Qquiz - Advinhe o quê é?",
			description:
				"O Quizz é um aplicativo móvel envolvente e educativo que desafia os usuários a testarem seus conhecimentos em uma ampla variedade de temas, incluindo matemática, história, ciências e esportes. Coloque seu boné de pensar e embarque em uma jornada de aprendizado, competição e diversão!",
			logos: [
				"../logosStacks/swift.png",
				"../logosStacks/swiftui.png",
				"../logosStacks/firebase.png",
				"../logosStacks/ios.png",
			],
			linkText: "Ver Projeto",
			link: "https://github.com/souza10v/qquiz",
		},

		{
			title: "Amazônia Explorer",
			description:
				"O Amazônia Explorer oferece uma experiência interativa e informativa sobre a região da Amazônia. Seu objetivo é aumentar a conscientização sobre a importância da Amazônia e incentivar a conservação desse ecossistema valioso.",
			logos: [
				"../logosStacks/swift.png",
				"../logosStacks/swiftui.png",
				"../logosStacks/firebase.png",
				"../logosStacks/ios.png",
			],
			linkText: "Ver Projeto",
			link: "https://github.com/souza10v/Amazonia",
		},

		{
			title: "HungryFinder App!",
			description:
				"O HungryFinder é um aplicativo conveniente e fácil de usar, projetado para ajudar os usuários a encontrar facilmente os restaurantes mais próximos com base em sua localização atual.",
			logos: [
				"../logosStacks/swift.png",
				"../logosStacks/swiftui.png",
				"../logosStacks/api.png",
				"../logosStacks/ios.png",
			],
			linkText: "Ver Projeto",
			link: "https://github.com/souza10v/City-Sights-App/tree/main",
		},

		{
			title: "QuakeSee - Em desenvolvimento",
			description: "Earthquake See: QuakeSEE é um aplicativo essencial para acompanhar terremotos na Nova Zelândia. Mantenha usuários informados sobre a atividade sísmica em tempo real, receba alertas de terremotos recentes e acesse dados detalhados sobre sua magnitude e localização.",
			logos: [
				"../logosStacks/swift.png",
				"../logosStacks/swiftui.png",
				"../logosStacks/api.png",
				"../logosStacks/ios.png",
			],
			linkText: "Ver Projeto",
			link: "https://github.com/souza10v/QuakeSee",
		},


	],
};

export default INFO;
